import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { MenuComponent } from './shared/components/menu/menu.component';
import { RackeoFooterShellComponent } from './shared/components/rackeo-footer-shell/rackeo-footer-shell.component';
import { RackeoCtaContactComponent } from './shared/components/rackeo-cta-contact/rackeo-cta-contact.component';
import { HomeComponent } from './home-page/home.component';
import { WebHostingComponent } from './web-hosting-page/web-hosting.component';
import { WebHostingPymeComponent } from './web-hosting-pyme-page/web-hosting-pyme.component';
import { VirtualizacionComponent } from './virtualizacion-page/virtualizacion.component';
import { ServidoresDedicadosComponent } from './servidores-dedicados-page/servidores-dedicados.component';
import { PagaDeudaComponent } from './paga-deuda/paga-deuda.component';
import { CheckComponent } from './paga-deuda/check/check.component';
import { StatusComponent } from './paga-deuda/status/status.component';
import { ResultsComponent } from './paga-deuda/results/results.component';
import { LoadingComponent } from './paga-deuda/loading/loading.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { NgxCaptchaModule } from 'ngx-captcha';
import { HttpClientModule } from '@angular/common/http';
import { MetaModule } from '@ngx-meta/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { HostingResellerComponent } from './hosting-reseller-page/hosting-reseller.component';
import { EmpresaShellComponent } from './empresa-page/empresa-shell/empresa-shell.component';
import { EmpresaNosotrosComponent } from './empresa-page/empresa-nosotros/empresa-nosotros.component';
import { EmpresaDataCenterComponent } from './empresa-page/empresa-data-center/empresa-data-center.component';
import { EmpresaFormasPagoComponent } from './empresa-page/empresa-formas-pago/empresa-formas-pago.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { RackeoCurrencyPipe } from './currency.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MenuComponent,
    RackeoFooterShellComponent,
    RackeoCtaContactComponent,
    HomeComponent,
    WebHostingComponent,
    WebHostingPymeComponent,
    VirtualizacionComponent,
    ServidoresDedicadosComponent,
    HostingResellerComponent,
    EmpresaShellComponent,
    EmpresaNosotrosComponent,
    EmpresaDataCenterComponent,
    EmpresaFormasPagoComponent,
    ErrorPageComponent,
    PagaDeudaComponent,
    CheckComponent,
    StatusComponent,
    ResultsComponent,
    LoadingComponent,
    RackeoCurrencyPipe,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'Rackeo' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    MetaModule.forRoot(),
    FormsModule,
    LayoutModule,
    HttpClientModule,
    NgxCaptchaModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDividerModule,
    MatListModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    IconSpriteModule.forRoot({ path: '/assets/img/sprites/sprite.svg' })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
